import { fetchServerStatus } from '@/lib/api/client/server-status';
import { useQuery } from '@tanstack/react-query';

export const useServerStatus = () => {
  const query = useQuery({
    queryKey: ['serverStatus'],
    queryFn: ({ signal }) => fetchServerStatus(signal),
    staleTime: 30_000,
    refetchInterval: 30_000,
    refetchOnReconnect: true
  });
  return {
    online: query.data?.status === 'online',
    isLoading: query.isLoading,
    isFetching: query.isFetching,
    isError: query.isError,
  };
};
